module.exports = __webpack_public_path__ + "img/MEDIA043.8a7329f7.jpg";